
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';
import { checkPermissionCompany } from '@/utils/permission';
import { IPagination } from '@/types';
import { parseTime } from '@/utils';
import DialogImgLarge from '@/components/ImgLarge/index.vue';
import {
  getStockCheckHistory,
  getStockCheckHistoryTime,
  stockCheckHistoryExport
} from '@/api/stock';

@Component({
  name: 'StockCheck',
  components: {
    DialogImgLarge
  }
})
export default class extends Vue {
  private formSearch: any = {
    datatime: '',
    stock_name: '',
    model_name: '',
    serial_number: '',
    specification: '',
    type: ''
  }
  private typeOptions = [{
    value: '1',
    label: '备件导入'
  }, {
    value: '2',
    label: '手动添加'
  }]
  private dataTable = []
  private pagination: IPagination = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  };
  private dialogselectedTimeVisible = false
  private timeselected = ''
  private timeMore = false
  private timeDataTable = []

  created() {
    this.getList();
    this.getTime();
  }

  private search() {
    this.getList();
  }

  private searchClean() {
    this.formSearch = {
      datatime: '',
      stock_name: '',
      model_name: '',
      serial_number: '',
      specification: '',
      type: ''
    };
    this.getList();
  }

  // 页面属性更新
  private handlePageSizeChange(val: any) {
    this.pagination.pageSize = val;
    this.getList();
  }
  private handleCurrentChange(val: any) {
    this.pagination.currentPage = val;
    this.getList();
  }

  private getList() {
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    if (this.formSearch.datatime) {
      params.datatime = this.formSearch.datatime;
    }
    params.stock_name = this.formSearch.stock_name;
    params.model_name = this.formSearch.model_name;
    params.serial_number = this.formSearch.serial_number;
    params.specification = this.formSearch.specification;
    params.type = this.formSearch.type;
    params.page = this.pagination.currentPage;
    params.size = this.pagination.pageSize;
    getStockCheckHistory(params)
      .then((res) => {
        if (res.data) {
          this.pagination.total = parseInt(res.data.count);
          this.dataTable = res.data.list;
        } else {
          this.pagination.currentPage = 1;
          this.pagination.total = 0;
          this.dataTable = [];
        }
      })
      .catch((error) => {
        this.dataTable = [];
        let msg = error.msg;
      });
  }

  private getTime() {
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    getStockCheckHistoryTime(params)
      .then((res) => {
        if(res.data==undefined || res.data.list==undefined  ){
          // this.timeDataTable = [];
        }else{
          this.timeDataTable = res.data.list;
        }
    
      })
      .catch((error) => {
        let msg = error.msg;
        this.showErrorMsg(msg);
      });
  }

  private selectTimeHandle() {
    this.dialogselectedTimeVisible = true;
  }
  private selectTime() {
    this.formSearch.datatime_date = parseTime(parseInt(this.timeselected), '{y}-{m}-{d} {h}:{i}');
    this.formSearch.datatime = this.timeselected;
    this.dialogselectedTimeVisible = false;
  }
  private exportHandle() {
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    if (this.formSearch.datatime) {
      params.datatime = this.formSearch.datatime;
    }
    params.stock_name = this.formSearch.stock_name;
    params.model_name = this.formSearch.model_name;
    params.serial_number = this.formSearch.serial_number;
    params.specification = this.formSearch.specification;
    params.type = this.formSearch.type;
    params.page = this.pagination.currentPage;
    params.size = this.pagination.pageSize;
    stockCheckHistoryExport(params)
      .then((res) => {
        this.$confirm('是否跳转下载页面？', '跳转', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let routeData = this.$router.resolve({
            path: '/ExportTask',
            query: {}
          });
          window.open(routeData.href);
        }).catch(() => {

        });
      })
      .catch((error) => {
        this.dataTable = [];
        let msg = error.msg;
      });
  }
  private checkHandle() {
    this.$router.push({
      path: 'check'
    });
  }

  private large(val:any) {
    let arr = [val];
    let enlargedData = {
      isShow: true,
      imgList: arr,
      initNum: 1
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }

  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}
